export const GET_RECOGNITION_DATA = 'get-recognition-data';
export const GET_BONUS_DATA = 'get-bonus-data';
